<ng-template vdrDialogTitle>
  {{ "common.selectSupplier" | translate }}
</ng-template>
<vdr-form-field label="Search by Name" *ngIf="queryParams | async">
  <input type="text" (input)="updateName($event.target.value)" />
</vdr-form-field>
<p *ngIf="isLoading">Loading...</p>
<div #scrollContainer *ngIf="suppliers$ | async as suppliers">
  <div *ngIf="suppliers.info as info">
    <div
      (click)="onSelect(sup)"
      class="supplier-item"
      *ngFor="let sup of suppliers.data"
    >
      {{ sup.name }} -- {{ sup.vendId }} -- {{ sup.code }}
    </div>
    <div
      [ngStyle]="{
        display: 'flex',
        'flex-direction': 'row',
        'justify-content': 'space-between',
        'align-items': 'center'
      }"
    >
      <div class="supplier-pagination">
        Showing
        <select
          class="mx-1"
          [(ngModel)]="info.pageSize"
          (ngModelChange)="onSizeSelect($event)"
        >
          <option *ngFor="let size of sizeOptions">
            {{ size }}
          </option>
        </select>
        suppliers
      </div>
      <div class="supplier-pagination">
        <div *ngFor="let button of pageIndexButtons(info.total); let i = index">
          <div class="supplier-pagination">
            <div
              *ngIf="
                (i !== 0 &&
                  button !== pageIndexButtons(info.total)[i - 1] + 1 &&
                  pageIndexButtons(info.total).length > 2) ||
                (i === pageIndexButtons(info.total).length - 1 &&
                  pageIndexButtons(info.total).length > 2)
              "
            >
              ...
            </div>
            <button
              *ngIf="info.pageIndex + 1 === button; else nonselect"
              class="button primary"
            >
              {{ button }}
            </button>
            <ng-template #nonselect>
              <button (click)="onPageIndexSelect(button - 1)" class="button">
                {{ button }}
              </button>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="supplier-pagination">
        Showing {{ info.offset + 1 }} - {{ info.offset + info.pageSize }} of
        {{ info.total }}
      </div>
    </div>
  </div>
</div>
